import { WorkerForSelect } from 'api/services/workers/workers-service.dto';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';

export const formatWorkerLabel = (worker: WorkerForSelect) => {
  return `${getFullNameWithInfix(worker)} (${worker.email})`;
};
